import React from 'react';
import ErrorHandler from '../ErrorHandler';
import PixiGame from '../PixiGame/PixiGame';
import GameInfoConsole from "../Core/GameInfoConsole"
import EmojiChatBox from "../Core/EmojiChatBox"
import OverlayHelpButtons from "../Core/OverlayHelpButtons"
import { gameStateManager } from '../../App';
import BannerAd from "../Ads/BannerAd";

const sidePanelWidth = 311;
const sidePanelPaddingX = 6;

export default class Room extends React.Component
{
  state = {
    warning: [ true, '', '' ],
    isReady: false,
    playersInRoom: [],
    error: '',
    stageRenderData: { width: 1350, height: 833, scale: 1.0 },
  };

  onRoomErrorCallbackHandle = null;

  componentDidMount()
  {
    this.updateStageScaling();

    this.onRoomErrorCallbackHandle = ( errorData ) =>
    {
      console.log( "Room onRoomError", errorData );

      this.setState( { error: errorData } );
    };

    gameStateManager.onRoomErrorRegister( this.onRoomErrorCallbackHandle );

    window.addEventListener( 'resize', this.updateStageScaling );
  }

  componentWillUnmount()
  {
    gameStateManager.onRoomErrorUnregister( this.onRoomErrorCallbackHandle );

    this.onRoomErrorCallbackHandle = null;

    window.removeEventListener( 'resize', this.updateStageScaling );
  }



  updatePlayers = playersInRoom =>
  {
    this.setState( { playersInRoom } );
  };

  resetError = () =>
  {
    this.setState( { error: '' } );
  };



  updateStageScaling = () =>
  {
    let includeLeftRightAdBanners = !process.env.REACT_APP_DISABLE_AD_BANNERS && window.innerWidth >= window.innerHeight;
    let includeBottomAdBanner = false;

    // console.log("window resized. " + window.innerWidth + "x" + window.innerHeight +  " , includeLeftRightAdBanners : " + includeLeftRightAdBanners);

    const bannerAdSpacingWidth = 165;
    const bottomBannerAdSpacingHeight = 95;
    const tallWindowLetterBoxingHeight = 30;

    const leftBannerWidth = includeLeftRightAdBanners ? bannerAdSpacingWidth : 0;
    const rightBannerWidth = includeLeftRightAdBanners ? bannerAdSpacingWidth : 0;

    let newStageWidth = window.innerWidth - leftBannerWidth - rightBannerWidth;;
    let newStageHeight = window.innerHeight;

    if( newStageHeight > 1000 )
    {
      // Add a letter boxing buffer
      newStageHeight -= tallWindowLetterBoxingHeight * 2;
    }

    if( newStageHeight > newStageWidth * ( 22.0 / 30.0 ) )
    {
      // Need to force the height to be within the min width ratio of 30:22
      newStageHeight = newStageWidth * ( 22.0 / 30.0 );
    }

    if( ( window.innerHeight - newStageHeight ) / 2 > bottomBannerAdSpacingHeight )
    {
      includeBottomAdBanner = true;
    }

    let newStageStyleTop = ( window.innerHeight - newStageHeight ) / 2.0;
    let scale = newStageHeight / gameStateManager.canvasRefHeight;

    const latestStageRenderData =
    {
      width: newStageWidth,
      height: newStageHeight,
      scale: scale,

      stageStyleTop: newStageStyleTop,
      showLeftRightAds: includeLeftRightAdBanners,
      showBottomAd: includeBottomAdBanner,
    };

    this.setState( { stageRenderData: latestStageRenderData } );

    gameStateManager.setNewStageRenderDataState( latestStageRenderData );
  };


  render()
  {
    const {
      error,
      stageRenderData,
    } = this.state;

    if( error )
    {
      return <ErrorHandler redirectUrl="/" error={ error } resetError={ this.resetError } />;
    }

    let includeLeftRightAdBanners = stageRenderData.showLeftRightAds;
    let includeBottomAdBanner = stageRenderData.showBottomAd;

    if( process.env.REACT_APP_DISABLE_AD_BANNERS )
    {
      includeLeftRightAdBanners = false;
      includeBottomAdBanner = false;
    }

    const clientSocketID = gameStateManager.socketClientID;

    return (
      <div className="pixigame-page colour-dark-shade-bg" >

        { includeLeftRightAdBanners &&
          (
            <div className="in-game-ad-left">
              <BannerAd
                slot="1718701611"
                customStyle={ { display: "inline-block", width: "150px", height: "600px" } }
                refreshSec={ process.env.REACT_APP_IN_GAME_VERTICAL_AD_REFRESH_FREQUENCY ?? 60 }
              />
            </div>
          )
        }

        { includeLeftRightAdBanners &&
          (
            <div className="in-game-ad-right">
              <BannerAd
                slot="8611413020"
                customStyle={ { display: "inline-block", width: "150px", height: "600px" } }
                refreshSec={ process.env.REACT_APP_IN_GAME_VERTICAL_AD_REFRESH_FREQUENCY ?? 60 }
              />
            </div>
          )
        }

        { includeBottomAdBanner &&
          (
            <div className="in-game-ad-bottom">
              <BannerAd
                slot="7087288807"
                customStyle={ { display: "inline-block", width: "728px", height: "90px" } }
                refreshSec={ process.env.REACT_APP_IN_GAME_FOOTER_AD_REFRESH_FREQUENCY ?? 60 }
              />
            </div>
          )
        }


        <PixiGame
          clientId={ clientSocketID }
          stageRenderData={ stageRenderData }
          sidePanelWidth={ sidePanelWidth + sidePanelPaddingX }
        />

        <GameInfoConsole
          stageRenderData={ stageRenderData }
          width={ stageRenderData.scale * sidePanelWidth }
          height={ stageRenderData.scale * 233 }
          top={ ( stageRenderData.stageStyleTop + 4 ) }
          right={ ( ( window.innerWidth - stageRenderData.width ) / 2 ) + sidePanelPaddingX }
        />

        <EmojiChatBox
          stageRenderData={ stageRenderData }
          width={ stageRenderData.scale * sidePanelWidth }
          height={ stageRenderData.scale * 232 }
          top={ stageRenderData.stageStyleTop + ( stageRenderData.scale * 237 ) + 4 }
          right={ ( ( window.innerWidth - stageRenderData.width ) / 2 ) + sidePanelPaddingX }
        />

        { process.env.REACT_APP_SHOW_OVERLAY_HELP_BUTTONS === 'true' &&
          <OverlayHelpButtons stageRenderData={ stageRenderData } />
        }

      </div>
    );
  }
}
